export default function SectionHeader({
  title,
  subtitle,
  action,
}: {
  title: string;
  subtitle?: string;
  action?: { label: string; onClick: () => void };
}) {
  return (
    <div className="flex items-end justify-between mb-8 md:mb-10">
      <div>
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-50">
          {title}
        </h2>
        {subtitle && (
          <p className="text-sm text-foreground-500 mt-2">{subtitle}</p>
        )}
      </div>
      {action && (
        <button
          onClick={action.onClick}
          className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer"
        >
          {action.label}
          <i className="ri-arrow-right-s-line text-base"></i>
        </button>
      )}
    </div>
  );
}